import React from 'react'
import NewSectionsLayout from './NewSectionLayout'

const NewSections = () => {
  return <NewSectionsLayout />
}

export default NewSections
